export const APPLICATION = {
  PLP_BANNER: 'plp-banner'
};

export const PAGE_TYPE = {
  PLP: 'PLP'
};

export const CUSTOMER_TYPE = {
  B2B: 'B2B',
  B2C: 'B2C'
};

export const ANCHOR_TYPE = {
  SEARCH_TERM: 'SEARCH_TERM'
};

export const CONTENT_TYPE = {
  SUMMARY: 'SUMMARY'
};

export const SEARCH_BANNER_CONFIG_KEY = 'fs-ai-assisted-search-banner';

export const SEARCH_BANNER_VARIANT = {
  DISABLED: 'disabled',
  VARIANT_A: 'variant-A',
  VARIANT_B: 'variant-B',
  VARIANT_C: 'variant-C'
};
